import React from 'react';
import Calendar from './Calendar';

// Components
import DueDateTimePicker from '../../element/task/pills/assignment/dueDate/DueDateTimePicker';
import PropTypes from 'prop-types';

import './SimpleDateTimePicker.scss';
import { useTranslator } from '../i18n/useTranslator';


// This date picker is a simplified version of the one used in the task due date picker.
// It is aimed more at general date/time selection rather than future/due dates

const SimpleDateTimePicker = ({ date, updateDate, hasTime, updateDateHasTime, locale }) => {
    const translate = useTranslator('popup', 'dateTime');
    const unsetTimeMessage = translate('addTime', 'Add time');

    return (
        <div className="SimpleDateTimePicker">
            <div className="calendar-section">
                <Calendar value={date} onChange={updateDate} futureOnly={false} locale={locale} />
            </div>

            <div className="time-section">
                <DueDateTimePicker
                    hasDueDateTime={hasTime}
                    setHasDueDateTime={updateDateHasTime}
                    dueDate={date}
                    setDueDate={updateDate}
                    unsetTimeMessage={unsetTimeMessage}
                />
            </div>
        </div>
    );
};

SimpleDateTimePicker.propTypes = {
    date: PropTypes.instanceOf(Date),
    updateDate: PropTypes.func,
    hasTime: PropTypes.bool,
    updateDateHasTime: PropTypes.func,
    locale: PropTypes.string,
};

export default SimpleDateTimePicker;
